export default {
    title: '首頁'
}